{
  "CUSTOM_ROLE": {
    "HEADER": "Funções personalizadas",
    "LEARN_MORE": "Aprenda mais sobre funções personalizadas",
    "DESCRIPTION": "Funções personalizadas são funções criadas pelo proprietário ou administrador da conta. Essas funções podem ser atribuídas a agentes para definir seu acesso e permissões dentro da conta. Funções personalizadas podem ser criadas com permissões e níveis de acesso específicos para atender aos requisitos da organização.",
    "COUNT": "{n} custom role | {n} custom roles",
    "HEADER_BTN_TXT": "Adicionar função personalizada",
    "LOADING": "Buscando funções personalizadas...",
    "SEARCH_PLACEHOLDER": "Search custom roles...",
    "NO_RESULTS": "No custom roles found matching your search",
    "SEARCH_404": "Não há itens correspondentes a esta consulta.",
    "PAYWALL": {
      "TITLE": "Atualize para criar funções personalizadas",
      "AVAILABLE_ON": "O recurso de função personalizada está disponível apenas nos planos \"Business\" e \"Enterprise\".",
      "UPGRADE_PROMPT": "Faça upgrade do seu plano para obter acesso a recursos avançados, como gestão de equipas, automações, atributos personalizados e muito mais.",
      "UPGRADE_NOW": "Fazer upgrade agora",
      "CANCEL_ANYTIME": "Pode alterar ou cancelar o plano a qualquer momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "O recurso de função personalizada está disponível apenas nos planos pagos.",
      "UPGRADE_PROMPT": "Faça upgrade para um plano pago para obter recursos avançados, como logs de auditoria, capacidade de agentes e muito mais.",
      "ASK_ADMIN": "Por favor, entre em contato com o administrador para atualização."
    },
    "LIST": {
      "404": "There are no custom roles available in this account.",
      "TITLE": "Gerir funções personalizadas",
      "DESC": "Funções personalizadas são funções criadas pelo proprietário ou administrador da conta. Essas funções podem ser atribuídas a agentes para definir seu acesso e permissões dentro da conta. Funções personalizadas podem ser criadas com permissões e níveis de acesso específicos para atender aos requisitos da organização.",
      "TABLE_HEADER": {
        "NAME": "Nome:",
        "DESCRIPTION": "Descrição",
        "PERMISSIONS": "Permissions",
        "ACTIONS": "Ações"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Manage all conversations",
      "CONVERSATION_UNASSIGNED_MANAGE": "Manage unassigned conversations and those assigned to them",
      "CONVERSATION_PARTICIPATING_MANAGE": "Manage participating conversations and those assigned to them",
      "CONTACT_MANAGE": "Manage contacts",
      "REPORT_MANAGE": "Manage reports",
      "KNOWLEDGE_BASE_MANAGE": "Manage knowledge base"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome:",
        "PLACEHOLDER": "Please enter a name.",
        "ERROR": "Nome é obrigatório."
      },
      "DESCRIPTION": {
        "LABEL": "Descrição",
        "PLACEHOLDER": "Please enter a description.",
        "ERROR": "Descrição obrigatória."
      },
      "PERMISSIONS": {
        "LABEL": "Permissões",
        "ERROR": "Permissão requerida."
      },
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente."
      }
    },
    "ADD": {
      "TITLE": "Adicionar função personalizada",
      "DESC": " Funções personalizadas permitem criar funções com permissões e níveis de acesso específicos para atender aos requisitos da organização.",
      "SUBMIT": "Submeter",
      "API": {
        "SUCCESS_MESSAGE": "Função personalizada adicionada com sucesso."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Editar",
      "TITLE": "Editar função personalizada",
      "DESC": " Funções personalizadas permitem criar funções com permissões e níveis de acesso específicos para atender aos requisitos da organização.",
      "SUBMIT": "Atualização",
      "API": {
        "SUCCESS_MESSAGE": "Função personalizada atualizada com sucesso."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "API": {
        "SUCCESS_MESSAGE": "Função personalizada excluída com sucesso.",
        "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente."
      },
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem certeza que deseja excluir agente ",
        "YES": "Sim, excluir ",
        "NO": "Não, manter "
      }
    }
  }
}
